import { FormElement, FormId } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
  ComplexFormSchemaComponents,
} from "../../../../components/types";
import {
  selectIncidentStatementsData,
  selectIsPerpetratorStatementSigned,
  selectWasPoliceInvolved,
  selectWasPoliceNotInvolved,
} from "../incident.selectors";
import { setPerpetratorStatement, setPolicePresence } from "../incident.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<
  SimpleFormSchemaComponents | ComplexFormSchemaComponents
> = {
  formId: FormId.INCIDENT_STATEMENTS,
  selector: selectIncidentStatementsData,
  content: [
    {
      title: "Oświadczenia",
      sections: [
        {
          id: "applicant-statements-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.INCIDENT_STATEMENTS_POLICE_PRESENT,
              required: true,
              label: "Czy na miejscu zdarzenia była policja?",
              onChange: setPolicePresence,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "applicant-statements-data-police-1",
          wrapper: { xs: 12 },
          isVisible: selectWasPoliceInvolved,
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.INCIDENT_STATEMENTS_POLICE_DEPARTMENT,
              required: true,
              label: "Jednostka policji",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.INCIDENT_STATEMENTS_CASE_NUMBER,
              label: "Numery sprawy",
            },
          ],
        },
        {
          id: "applicant-statements-data-police-2",
          title:
            "Dodaj zdjęcie protokołu policji jeśli je posiadasz (maksymalnie 10 plików)",
          wrapper: { xs: 12 },
          isVisible: selectWasPoliceInvolved,
          components: [
            {
              type: FormElement.IMAGE_UPLOADER_MULTIPLE,
              id: ComponentId.INCIDENT_STATEMENTS_POLICE_IMAGES,
              maxImageNumber: 10,
              imageSectionId: ComponentId.INCIDENT_STATEMENTS_POLICE_IMAGES,
            },
          ],
        },
        {
          id: "applicant-statements-data-perpetrator-1",
          wrapper: { xs: 12 },
          isVisible: selectWasPoliceNotInvolved,
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.INCIDENT_STATEMENTS_PERPETRATOR_STATEMENT,
              required: true,
              label: "Czy zostało spisane oświadczenie sprawcy?",
              onChange: setPerpetratorStatement,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "applicant-statements-data-perpetrator-2",
          title:
            "Dodaj zdjęcie oświadczenia sprawcy jeśli je posiadasz (maksymalnie 10 plików)",
          wrapper: { xs: 12 },
          isVisible: selectIsPerpetratorStatementSigned,
          components: [
            {
              type: FormElement.IMAGE_UPLOADER_MULTIPLE,
              id: ComponentId.INCIDENT_STATEMENTS_PERPETRATOR_IMAGES,
              maxImageNumber: 10,
              imageSectionId:
                ComponentId.INCIDENT_STATEMENTS_PERPETRATOR_IMAGES,
            },
          ],
        },
      ],
    },
  ],
};
